import { Component, ChangeDetectionStrategy, input, computed, inject, output } from '@angular/core';
import { AbstractComponent } from '@spike/scaffolds';
import { WalletRecap } from '../../models/wallet-recap.model';
import { CommonModule } from '@angular/common';
import { WalletStoreService } from '../../services/etiquette-service/wallet-store.service';

@Component({
  selector: 'spike-wallet-recap',
  templateUrl: './wallet-recap.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class WalletRecapComponent extends AbstractComponent {
  public readonly walletStoreService = inject(WalletStoreService);
  wallets = input.required<WalletRecap[]>();
  onSelect = output<WalletRecap>();
  
  public readonly total = computed(()=>{
    const wallets = this.wallets();
    return wallets.reduce((acc, curr) => {
      return {
        ...acc,
        liquidityAmount: acc.liquidityAmount + curr.liquidityAmount,
        investmentAmount: acc.investmentAmount + curr.investmentAmount,
      };
      }, { 
        finWalletId: 0, 
        liquidityAmount: 0, 
        investmentAmount: 0, 
        shortDescription: 'Totale' 
      } as WalletRecap);
  });

  public readonly grandTotal = computed(()=>{
    const total = this.total();
    return total.investmentAmount+ total.liquidityAmount;
  });

}
